import { NgModule } from '@angular/core';
import { AlertComponent } from './alert.component'
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';

@NgModule({
  exports: [AlertComponent],
  declarations: [AlertComponent],
  imports: [
    CommonModule,
    MatIconModule
  ]
})
export class AlertModule {}
